import classNames from 'classnames/bind';
import styles from './TableHead.module.css';
import Select from '../../Select';

interface TableHead {
  list: string[];
  selectOptions?: {
    idx: number;
    default: { key: string; value: string };
    values: string[];
    onClick: (value: string, i: number) => void;
  };
}

export default function TableHead({ list, selectOptions }: TableHead) {
  const cx = classNames.bind(styles);

  return (
    <div className={cx('table_head')}>
      {list.map((header, i) =>
        i === selectOptions?.idx ? (
          <Select
            key={header}
            list={selectOptions?.values}
            value={selectOptions?.default.value}
            onClick={selectOptions?.onClick}
          />
        ) : (
          <span key={header}>{header}</span>
        )
      )}
    </div>
  );
}
